export default __webpack_public_path__ + "static/media/ill-submitted.310f5934.svg";